import compose from 'core/libs/helpers/compose.js';
import withScores from 'core/libs/hoc/withScores';
import withUserScore from 'core/libs/hoc/withUserScore';
import NewDesignButton from 'modules/common/NewDesignButton';
import NextButton from 'modules/common/NextButton';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {connect} from 'react-redux';
import quizAudio from 'theme/assets/audios/correct-answer.mp3';
import Bonus from 'theme/assets/images/bonus.svg';
import failed from 'theme/assets/images/failed.svg';
import passed from 'theme/assets/images/passed.svg';
import {animateFlicker, label, pointsLeft} from './styles.scss';

const QuizResult = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    nextStepProps,
    quizTotalResult,
    score,
    tryAgain,
    lastTopTenScore,
    currentUserScore,
  } = props;
  const won = quizTotalResult.answers_correct - quizTotalResult.min_score >= 0;
  const pointsToReachTopTen =
    lastTopTenScore && lastTopTenScore - currentUserScore;
  return (
    <div className="tc">
      <div className="pv5 tc w-60-ns w-80-m w-90 center bb b--light-gray bw1">
        {won && (
          <div className="pv2-ns pv3-m pv4">
            <img src={passed} alt="passed icon" />
            <h1 className="mb3">
              <FormattedMessage id="congratulations" />!
            </h1>
            <h2 className="mt1 mb3 normal gray">
              <FormattedMessage id="quiz_completed" />!
            </h2>
            <div className="pv3">
              <h3 className="mb4">
                <FormattedMessage id="correct" /> :{' '}
                <span className="green">{quizTotalResult.answers_correct}</span>
              </h3>
              <h3>
                <FormattedMessage id="wrong_answer" /> :{' '}
                <span className="red">{quizTotalResult.answers_incorrect}</span>
              </h3>
            </div>
            {score > 0 && (
              <div>
                <img src={Bonus} alt="bonus icon" />
                <h2 className={`mt3 green f4 b fw3 ${animateFlicker}`}>
                  +{score} <FormattedMessage id="points_max" />
                </h2>
              </div>
            )}
            {pointsToReachTopTen !== null && pointsToReachTopTen > 0 && (
              <p className={`pa2 b mt3 ${label}`}>
                <FormattedMessage
                  id="step_result_label"
                  values={{
                    points: (
                      <div className={`white ${pointsLeft}`}>
                        {lastTopTenScore - currentUserScore - score}
                      </div>
                    ),
                  }}
                />
              </p>
            )}
            <audio src={quizAudio} controls autoPlay hidden />
          </div>
        )}
        {!won && (
          <div className="pv2-ns pv3-m pv4">
            <img src={failed} alt="failed icon" />
            <h1 className="mb3">
              <FormattedMessage id="sorry" />!
            </h1>
            <h2 className="mt1 normal gray">
              <FormattedMessage id="retry" />
            </h2>
            <div className="pv3">
              <h3 className="mb4">
                <FormattedMessage id="correct" /> :{' '}
                <span className="green">{quizTotalResult.answers_correct}</span>
              </h3>
              <h3>
                <FormattedMessage id="wrong_answer" /> :{' '}
                <span className="red">{quizTotalResult.answers_incorrect}</span>
              </h3>
            </div>
          </div>
        )}
        {!won ? (
          <NewDesignButton
            className="pa3-ns bg-green-light bg-animate hover-bg-green"
            onClick={tryAgain}
          >
            <FormattedMessage id="try_again" />
          </NewDesignButton>
        ) : null}
      </div>
      {won && (
        <div className="pv5-ns pv3-m pv2 pl6-ns pl0-m pl0 tl-ns tc-m tc">
          <NextButton
            {...nextStepProps}
            pretext={`${formatMessage({
              id: 'continue',
            })} :`}
          />
        </div>
      )}
    </div>
  );
};

QuizResult.propTypes = {
  quizTotalResult: PropTypes.object.isRequired,
  score: PropTypes.number.isRequired,
  tryAgain: PropTypes.func.isRequired,
  lastTopTenScore: PropTypes.number,
  currentUserScore: PropTypes.number,
};

const mapStateToProps = ({user, leaderboard: {userScore, scores}}) => {
  return {
    user: user.profile.data,
    currentUserScore:
      (userScore && userScore.data && userScore.data.score) || 0,
    lastTopTenScore:
      scores &&
      scores.data &&
      scores.data.length > 0 &&
      scores.data[scores.data.length - 1] &&
      scores.data[scores.data.length - 1].total_score,
  };
};

const enhance = compose(
  connect(mapStateToProps),
  withScores({force: true, callOnUpdate: false}),
  withUserScore({force: true, callOnUpdate: false}),
);

export default enhance(QuizResult);
